// extracted by mini-css-extract-plugin
module.exports = {"tags":"ArticleMeta_tags__6oYN2"};